<!-- 表1填写 -->

<template>
  <div class="tabCage table1">
    <i class="el-icon-refresh-left"></i>
    <i class="el-icon-refresh-right"></i>
    <div class="tabTtl">
      <span>表 1-9：出版经营情况调查表</span>
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务<br />所在出版单位(非部门)<br />具有的出版资质包括：
            </td>
            <td class="edInp">
              <el-checkbox
                disabled
                v-model="params.qualificationTs"
                true-label="1"
                false-label="0"
                label="图书"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationQk"
                true-label="1"
                false-label="0"
                label="期刊"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationYx"
                true-label="1"
                false-label="0"
                label="音像"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationDz"
                true-label="1"
                false-label="0"
                label="电子"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationWl"
                true-label="1"
                false-label="0"
                label="网络"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.qualificationBz"
                true-label="1"
                false-label="0"
                label="报纸"></el-checkbox>
            </td>
          </tr>
          <tr>
            <td class="edName">所在出版单位<br />主营出版业务<br />(营收高于音像电子业务的出版业务）：</td>
            <td class="edInp">
              <!-- <el-checkbox-group disabled v-model="cbzz2Array" style="line-height:22px;"> -->
              <el-checkbox
                disabled
                v-model="params.mainBusinessTs"
                true-label="1"
                false-label="0"
                label="图书"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.mainBusinessQk"
                true-label="1"
                false-label="0"
                label="期刊"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.mainBusinessWl"
                true-label="1"
                false-label="0"
                label="网络"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.mainBusinessBz"
                true-label="1"
                false-label="0"
                label="报纸"></el-checkbox>
              <el-checkbox
                disabled
                v-model="params.mainBusinessRm1"
                true-label="1"
                false-label="0"
                label="无"></el-checkbox>
              <!-- </el-checkbox-group> -->
            </td>
          </tr>
          <tr>
            <td class="edName">所在出版单位<br />是否主营有其他业务<br />（营收高于出版业务的业务）：</td>
            <td class="edInpTextArea">
              <!-- placeholder="请输入所在出版单位主营出版业务(营收高于音像电子业务的出版业务）" -->
              <el-input
                type="textarea"
                :rows="3"
                disabled
                v-model="params.otherbusiness"
                placeholder="请输入"
                size="small"></el-input>
            </td>
          </tr>

          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务<br />除传统光盘载体出版外<br />在哪些方面有所拓展：
            </td>
            <td class="edInp">
              <!-- <el-checkbox-group disabled v-model="extendyw" style="line-height:22px;"> -->
              <el-checkbox
                disabled
                v-model="params.expandBusinessMedium"
                true-label="1"
                false-label="0"
                label="新媒体"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessWeb"
                true-label="1"
                false-label="0"
                label="直接通过网络传播的出版物"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessBook"
                true-label="1"
                false-label="0"
                label="图书出版物(此项由盘配书试点单位选填)"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessLxdz"
                true-label="1"
                false-label="0"
                label="连续型电子/网络出版物"></el-checkbox
              ><br />
              <el-checkbox disabled v-model="params.expandBusinessOther" true-label="1" false-label="0" label="其他">
              </el-checkbox>
              <el-input
                v-if="params.expandBusinessOther == '1'"
                disabled
                v-model="params.expandBusinessOtherFill"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请输入其他"></el-input
              ><br />
              <el-checkbox
                label="无"
                disabled
                v-model="params.expandBusinessEmpty"
                true-label="1"
                false-label="0"></el-checkbox>
              <!-- </el-checkbox-group> -->
            </td>
          </tr>
          <tr>
            <td class="edName">
              从事<span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务<br />的单位或部门<br />结合<span
                v-if="pressType == 1"
                >音像</span
              >
              <span v-else-if="pressType == 2">电子</span>业务<br />开设并运营有以下项目：
            </td>
            <td class="edInp">
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  disabled
                  v-model="params.operationProjectWeb"
                  true-label="1"
                  false-label="0"
                  label="业务网站"></el-checkbox>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectWebNum"
                  size="small"
                  placeholder="数量"></el-input-number>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  disabled
                  v-model="params.operationProjectDatabase"
                  true-label="1"
                  false-label="0"
                  label="专业数据库"></el-checkbox>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectDatabaseNum"
                  size="small"
                  placeholder="数量"></el-input-number>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  disabled
                  v-model="params.operationProjectWechat"
                  true-label="1"
                  false-label="0"
                  label="微信公众号"></el-checkbox>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectWechatNum1"
                  size="small"
                  placeholder="数量"></el-input-number>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <span class="chboxLeft"></span>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectWechatNum2"
                  size="small"
                  placeholder="数量"></el-input-number>
                <span class="suffixTitle">（总用户数）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  disabled
                  v-model="params.operationProjectApp"
                  true-label="1"
                  false-label="0"
                  label="小程序或APP"></el-checkbox>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectAppNum"
                  size="small"
                  placeholder="数量"></el-input-number>
                <span class="suffixTitle">（小程序用户数或APP下载量）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  disabled
                  v-model="params.operationProjectWeibo"
                  true-label="1"
                  false-label="0"
                  label="微博"></el-checkbox>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectWeiboNum"
                  style="width: 200px"
                  size="small"
                  placeholder="粉丝数"></el-input-number>
                <span class="suffixTitle">（粉丝数）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  style="width: 200px"
                  disabled
                  v-model="params.operationProjectOther"
                  true-label="1"
                  false-label="0"
                  label="其他（与第三方平台合作)"></el-checkbox>
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  disabled
                  :controls="false"
                  v-model="params.operationProjectOtherNum"
                  style="width: 120px"
                  size="small"
                  placeholder="平台数量"></el-input-number>
                <span class="suffixTitle">（个）</span>
              </div>
              <div class="chboxDiv">
                <el-checkbox
                  class="chboxLeft"
                  disabled
                  v-model="params.operationProjectEmpty"
                  true-label="1"
                  false-label="0"
                  label="无"></el-checkbox>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>人员情况</span>
      </div>

      <div class="editArea">
        <table>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span> <span v-else-if="pressType == 2">电子</span>出版单位(社)领导：
            </td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.zbSld"
                size="small"
                placeholder="数量"></el-input-number>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务人员中<br />编辑人员：
            </td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.zbBjry"
                size="small"
                placeholder="数量"></el-input-number>
            </td>
          </tr>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版业务人员中<br />除编辑以外<br />有关制作加工等相关人员：
            </td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.pepnumProcess"
                size="small"
                placeholder="数量"></el-input-number>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">
              <span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span
              >出版业务人员中<br />中除编辑以外<br />的有关新媒体、网络运营等技术人员：
            </td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.pepnumInternation"
                size="small"
                placeholder="数量"></el-input-number>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">
              出版业务人员中<br />除编辑以外<br />的专职<span v-if="pressType == 1">音像</span>
              <span v-else-if="pressType == 2">电子</span>出版物发行人员：
            </td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.pepnumIssue"
                size="small"
                placeholder="数量"></el-input-number>
              <br />
            </td>
          </tr>

          <tr>
            <td class="edName">其他人员（包括行政人员等）：</td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.pepnumOther"
                size="small"
                placeholder="数量"></el-input-number>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">总人数（以上6项合计）：</td>
            <td class="edInp">
              <el-input-number
                controls-position="right"
                :min="0"
                :precision="0"
                disabled
                :controls="false"
                v-model="params.pepnumTotal"
                size="small"
                placeholder="数量"></el-input-number>
              <br />
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input disabled v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input disabled v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input disabled v-model="params.updatedAt" size="small"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>
<style scoped>
.chboxDiv {
  overflow: hidden;
}

.chboxLeft {
  margin-top: 13px;
  float: left;
  width: 120px;
}

.chboxRight {
  float: left;
  margin-left: 5px;
}

.chboxRightInput {
  width: 243px;
}
</style>
<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt209";
import {
  tabRead209, // 信息读取
} from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
import Upbtn from "@/views/components/uploadCards";
// import Upbtn from '@/views/components/upload';

export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      pressType: this.$route.query.pressType,
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 2,
      imgId: "",

      CompanyNatureMap: {},
      declare: {
        personnel: "",
        contact: "",
      },
      pubStatus: 0,
    };
  },
  watch: {},
  methods: {
    dictInit: function () {
      let nameArr = ["C001", "C018", "C019", "C003", "C004"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });
      let vm = this;
      newPromise.then((result) => {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (let key in this.isNot) {
        }
      });
    },

    tabReEdit: function () {
      console.log("信息读取", this.$route.query.mtId);
      tabRead209({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        // console.log('response.pquestionnaire=',JSON.stringify(response.pquestionnaire))
        this.params = response.pquestionnaire;
        this.params.publishMaterialId = this.$route.query.mtId;

        this.declare.publishMaterialId = this.$route.query.mtId;
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },
    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },
    changeHandle: function (code) {
      let newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.clDate).getTime() > newDate) {
          this.params.clDate = "";
          this.$message.error("成立时间不可大于当前日期！");
        } else {
          if (!this.params.startYyDate) {
            this.params.startYyDate = this.params.clDate;
          }
        }
      } else if (code == 2) {
        if (new Date(this.params.startYyDate).getTime() > newDate) {
          this.params.startYyDate = "";
          this.$message.error("营业开始时间不可大于当前日期！");
        } else if (this.params.endYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.startYyDate = "";
            this.$message.error("营业开始时间不可大于营业结束日期！");
          }
        }
      } else if (code == 3) {
        if (this.params.startYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.endYyDate = "";
            this.$message.error("营业结束日期不能小于营业开始日期！");
          }
        }
      } else if (code == 4) {
        if (new Date(this.params.djDate).getTime() > newDate) {
          this.params.djDate = "";
          this.$message.error("营业登记时间不可大于当前日期！");
        }
      }
    },
    // 返回上一页
    goBack: function () {
      this.$router.go(-1);
    },
  },
  created: function () {
    console.log("this.$route.query.pgress=", this.$route.query.pgress);
    this.pubStatus = this.$route.query.pubStatus;
    this.dictInit();
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table1 {
  .tabTtl {
    .el-button {
      float: right;
    }
  }

  margin-top: 0;

  .areaTime .el-form-item {
    display: inline-block;
  }

  .areaTime .midSpan {
    margin: 0px 6px;
  }

  .edSelect .el-form-item {
    display: inline-block;
  }

  .upBtn {
    display: inline-block;
  }

  .editArea table .edName {
    width: 210px;
  }

  .icons {
    padding-left: 35px;

    img {
      display: block;
      margin: 6px 0 0 20px;
      float: left;
      cursor: pointer;
    }

    .el-button {
      margin-left: 20px;
    }
  }
}

.table1 .tips {
  display: inline-block;
  margin-left: 12px;
}

.table1 .uploadLine {
  vertical-align: text-top;
  padding-top: 5px;
}

.table1 .numLine {
  padding-bottom: 15px;
}

.table1 .numInp {
  display: inline-block;
  margin-bottom: 12px;
}

.table1 .numInp .inpName {
  display: inline-block;
  width: 180px;
  text-align: right;
}

.table1 .numInp .inpText {
  display: inline-block;
  padding-left: 12px;
}

.table1 .numInp .inpText input {
  border-radius: 0;
}

.el-date-editor {
  border-radius: 0;
}

.table1 .el-textarea {
  width: 350px;
}

.table1 .edInp .el-input-number {
  width: 300px;
}

.tabCage .editArea table .edInp .el-input {
  width: auto;
}

.table1 .spMake .el-form-item {
  display: inline-block;
  vertical-align: middle;
}

.suffixTitle {
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// table209.vue?2ba0b8f4